export default {
  PAGE_TITLE: "My Career",
  BETA_NOTICE: "Module in testing phase",
  BUTTON_TEXT : "Explore career plans!",
  INPUT_PLACEHOLDER : "Type your message...",
  CHAT_HEADER_TEXT : "Chat with Lumi",
  BTN_DELETE:"Delete",
  BTN_DELETE_CONFIRM: "Are you sure you want to delete this message? This action is irreversible.",
  BTN_DELETE_CONFIRM_TITLE: "Delete Confirmation",
  BTN_DELETE_CONFIRM_CANCEL: "Cancel",
  TSTR_SUCCESS: "Message deleted",
  TSTR_ERROR: "Error deleting message",
  PLAN_VALIDATED: "The career plan has been successfully validated",
  ERROR_VALIDATING_PLAN: "Error validating the plan",
  PLAN_DEACTIVATED: "The career plan has been successfully deactivated",
  ERROR_DEACTIVATING_PLAN: "Error deactivating the plan",
  SURVEYS: {
    TITLE: "Surveys",
    NO_SURVEYS: "No surveys for the moment, we'll notify you when there are new ones.",
  },
  PLAN_TRACKING_TITLE: "Action Plan / Tracking",
  CHAT_MESSAGE:'You are chatting with an AI assistant who can make mistakes. Consider verifying important information.',
  ADD_MEETING_TITLE: "Add a Meeting",
  LABEL_MEETING_DATE: "Meeting date",
  VALIDATION_REQUIRED_DATE: "Date is required",
  LABEL_HOUR: "Hour",
  LABEL_MINUTE: "Minute",
  LABEL_SUBJECT: "Subject",
  VALIDATION_REQUIRED_SUBJECT: "Subject is required",
  BTN_ADD_MEETING: "Add meeting",

  ADD_TRAINING_TITLE: "Add a Training",
  LABEL_TRAINING: "Training",
  PLACEHOLDER_TRAINING: "Search for a training",
  VALIDATION_REQUIRED_TRAINING: "Training is required",
  LABEL_START_DATE: "Start date",
  LABEL_END_DATE: "End date",
  VALIDATION_REQUIRED_START_DATE: "Start date is required",
  VALIDATION_REQUIRED_END_DATE: "End date is required",
  VALIDATION_DATE_RANGE: "End date must be after start date",
  BTN_ADD_TRAINING: "Add training",

  SECTION_MEETINGS: "Meetings:",
  SECTION_TRAININGS: "Trainings:",
  NO_MEETINGS: "You have no meetings scheduled",
  NO_TRAININGS: "You have no trainings to follow",

  FORMATIONS_CERTIFICATIONS:"Training and certifications obtained",
  BILAN_COMPETENCES: "My skills assessment to develop",
  SHARE_WITH_MANAGER: "Share with my manager",

  ADD_PLAN:'Add a plan',

  PAGE_COLLAB_TITLE: "Collaborators' Careers",

  // Buttons & Menus
  BTN_CREATE_PLAN: "Create Career Plan",
  BTN_VIEW: "View",
  BTN_VIEW_TOOLTIP: "View Career Plan",
  BTN_SELECT_USER_PLACEHOLDER: "Select a collaborator",
  SEARCH_PLACEHOLDER: "Search for a collaborator",
  NO_USER_FOUND: "No collaborator found",
  
  // Table Headers
  TABLE: {
    COLLABORATOR: "COLLABORATOR",
    CURRENT_POSITION: "CURRENT POSITION",
    STATUS: "STATUS",
    ACTIONS: "ACTIONS"
  },

  // Status
  STATUS: {
    DRAFT: "Draft",
    IN_PROGRESS: "In Progress",
    COMPLETED: "Achieved"
  },

  // Misc
  NO_DATA: "No data available",

  // Loading
  LOADING: {
    SPINNER_LABEL: "Loading...",
  },

  // Sort Tooltip or Label (optional if used)
  SORT: {
    BY_CURRENT_POSITION: "Sort by Current Position",
    BY_STATUS: "Sort by Status"
  },

  // Paginator (if customized)
  PAGINATION: {
    NEXT: "Next",
    PREV: "Previous",
    PAGE: "Page",
    OF: "de",
    ITEMS_PER_PAGE: "Items per page"
  },
  BTN_DESACTIVATE: "Deactivate plan",
  PLAN_STATUS_LABEL: "Plan Status",
  OBJECTIVES: {
  TITLE: "My Career Objectives",
  OBJECTIVES_LABEL: "Objectives:",
  ASPIRATIONS_LABEL: "Professional aspirations:",
  MISSING_SKILLS_LABEL: "Skills to develop:"
  },
  PROGRESS:'Global progress gauge',
  SKILLS_TO_DEVELOP: "My skills assessment to develop",
  PROGRESS_MESSAGE: {
    START: "You're just starting your journey! Every step brings you closer to your goal.",
    EARLY: "Great start! You're laying the foundation for a solid future.",
    MID: "You're making great progress! Keep going, you're halfway there.",
    LATE: "More than halfway through! Stay the course, the goal is in sight.",
    FINAL: "You're almost there! One last push to validate your career plan."
  },
  CURRENT_SKILLS: "My current skills",
  AQUIRED_SKILLS: "Skills acquired",
  TO_DEVELOP_SKILLS: "Skills to develop",
    SKILLS: {
    ACQUIRED: "Acquired Skills",
    TO_DEVELOP: "Skills to Develop",
    TOTAL: "Skills"
  },
  TRAININGS: {
    MY_PROGRESS: "My training progress",
    STATUS: {
      TO_FOLLOW: "To follow",
      IN_PROGRESS: "In progress",
      ACHIEVED: "Achieved",
      LATE: "Late"
    }
  },
  COMMENT: {
    TITLE:'Manager Comment',
    NO_COMMENTS: 'No comment from the manager',
    MODIFIED: "Modified on",
    SAVE: "Save",
    CANCEL: "Cancel"
  }
}